import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, of} from 'rxjs';

import {Message} from './message';

const messageTypes = {
  error: {
    title: 'Error',
    class: 'alert-danger',
    classImage: 'fas fa-exclamation-circle'
  },
  info: {
    title: 'Information',
    class: 'alert-info',
    classImage: 'fas fa-info-circle'
  },
  success: {
    title: 'Success',
    class: 'alert-success',
    classImage: 'fas fa-info-circle'
  },
  warning: {
    title: 'Warning',
    class: 'alert-warning',
    classImage: 'fas fa-exclamation-circle'
  }
};

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  public messages: Message[] = [];

  constructor() {
  }

  public success(text: string) {
    this.add(text, messageTypes.success);
  }

  public error(text: string) {
    this.add(text, messageTypes.error);
  }

  public remove(message) {
    const index = this.messages.indexOf(message);
    if (index > -1) {
      this.messages.splice(index, 1);
    }
  }

  public removeAll() {
    this.messages = [];
  }

  private add(text, type) {
    this.messages.push({
      text,
      type,
      /* used as elementId in the DOM to scroll to if we add,
         and way to find message to remove when dismissed or when "dissolve" if we add that */
      id: 'message' + (new Date().valueOf())
    });
  }

  getMessagesAsObservable() {
    // return this.messages.asObservable();
  }
}
